import Vue from 'vue';
export default Vue as LoniComponent;